import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './ProgressDialog.css';

const ProgressDialog = ({ show, message = 'Loading...', percent = null, inline = false }) => {
  const determinate = typeof percent === 'number';

  const content = (
    <div className="progress-dialog-body">
      <div className="progress-visual">
        {determinate ? (
          <div className="neon-ring-wrap" aria-hidden>
            {(() => {
              const size = 100;
              const stroke = 8;
              const r = (size - stroke) / 2;
              const c = 2 * Math.PI * r;
              const pct = Math.max(0, Math.min(100, percent));
              const offset = c - (pct / 100) * c;
              const angle = (pct / 100) * 360;
              return (
                <div className="neon-ring" style={{ width: size, height: size }}>
                  <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="neon-svg">
                    <defs>
                      <linearGradient id="neon-grad" x1="0" x2="1">
                        <stop offset="0" stopColor="#00f5a0" />
                        <stop offset="1" stopColor="#6a11cb" />
                      </linearGradient>
                    </defs>
                    <circle className="neon-bg" cx={size / 2} cy={size / 2} r={r} strokeWidth={stroke} fill="none" />
                    <circle
                      className="neon-fg"
                      cx={size / 2}
                      cy={size / 2}
                      r={r}
                      stroke="url(#neon-grad)"
                      strokeWidth={stroke}
                      fill="none"
                      strokeDasharray={c}
                      strokeDashoffset={offset}
                    />
                  </svg>
                  <div className="comet-wrap" style={{ transform: `rotate(${angle}deg)` }}>
                    <div className="comet" />
                  </div>
                </div>
              );
            })()}
          </div>
        ) : (
          <div className="neon-ring-wrap indeterminate" aria-hidden>
            <div className="neon-ring" style={{ width: 100, height: 100 }}>
              <svg width={100} height={100} viewBox={`0 0 100 100`} className="neon-svg">
                <defs>
                  <linearGradient id="neon-grad-2" x1="0" x2="1">
                    <stop offset="0" stopColor="#00f5a0" />
                    <stop offset="1" stopColor="#6a11cb" />
                  </linearGradient>
                </defs>
                <circle className="neon-bg" cx={50} cy={50} r={42} strokeWidth={8} fill="none" />
                <circle className="neon-arc" cx={50} cy={50} r={42} strokeWidth={8} stroke="url(#neon-grad-2)" fill="none" strokeLinecap="round" />
              </svg>
              <div className="comet-wrap orbiting">
                <div className="comet" />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="progress-message">{message}{determinate ? ` — ${Math.round(percent)}%` : ''}</div>
    </div>
  );

  if (inline) {
    return show ? <div className="progress-dialog-inline">{content}</div> : null;
  }

  return (
    <Modal
      show={!!show}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="progress-dialog-content"
      className="progress-dialog"
    >
      {content}
    </Modal>
  );
};

ProgressDialog.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.string,
  percent: PropTypes.number,
  inline: PropTypes.bool,
};

export default ProgressDialog;
